import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const getUserProfile = createAsyncThunk(
  "user/getUserProfile",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/user/profile", { params: filters });
      console.log("User profile fetched:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error fetching user profile:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to fetch user profile");
    }
  }
);

// Update user profile
export const updateUserProfile = createAsyncThunk(
  "user/updateUserProfile",
  async (profileData, { rejectWithValue }) => {
    try {
      const response = await api.put("/user/profile", profileData);
      console.log("User profile updated:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error updating user profile:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to update user profile");
    }
  }
);

export const redeemReferralPoints = createAsyncThunk(
  "user/redeemReferralPoints",
  async (recordId, { rejectWithValue }) => {
    try {
      const response = await api.post("/referral/redeem", { recordId });
      console.log("Points redeemed:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error redeeming points:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to redeem points");
    }
  }
);

export const getRedeemableSummary = createAsyncThunk(
  "user/getRedeemableSummary",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/referral/redeemable-summary");
      return response.data;
    } catch (err) {
      console.error("Error fetching redeemable summary:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to fetch redeemable summary");
    }
  }
);

// NOTE: Get referral stats with payment history
export const getReferralStats = createAsyncThunk(
  "user/getReferralStats",
  async (_, { rejectWithValue }) => {
      const response = await api.get("/referral/stats");
      return response.data;
  }
);

// NOTE: Add quick message to user
export const addQuickMessage = createAsyncThunk(
  "user/addQuickMessage",
  async ({ userId, message }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/user/${userId}/quick-message`, {
        message: message.trim(),
      });
      return response.data;
    } catch (err) {
      console.error("Error adding quick message:", err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to add quick message"
      );
    }
  }
);

// NOTE: Remove quick message from user
export const removeQuickMessage = createAsyncThunk(
  "user/removeQuickMessage",
  async ({ userId, messageIndex }, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/user/${userId}/quick-message`, {
        data: {
          messageIndex,
        },
      });
      return response.data;
    } catch (err) {
      console.error("Error removing quick message:", err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to remove quick message"
      );
    }
  }
);